import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import Reveal from './Reveal.jsx';
import UsnViewer from './UsnViewer.jsx';

const Section = styled.div`
  padding: 70px 100px;
  border-top: 2px solid ${theme.border};
  @media (max-width: 900px) {
    padding: 50px 24px;
  }
`;
const Label = styled.div`
  font-family: ${theme.fontMono};
  font-size: 13px;
  letter-spacing: 0.08em;
  color: ${theme.accent};
  text-transform: uppercase;
  margin-bottom: 14px;
`;
const Statement = styled.p`
  margin: 0 0 40px 0;
  font-family: ${theme.fontHeading};
  font-weight: 800;
  font-size: 28px;
  line-height: 1.3;
  text-transform: uppercase;
  letter-spacing: -0.01em;
  max-width: 760px;
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  gap: 36px;
`;
const Card = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
  background: ${theme.card};
  border: 1px solid ${theme.borderLight};
  padding: 30px;
  box-shadow: 10px 10px 0 ${theme.border};
  @media (max-width: 700px) {
    flex-direction: column;
    align-items: stretch;
  }
`;
const Viewer = styled.div`
  width: 260px;
  height: 260px;
  flex-shrink: 0;
  background: ${theme.bg};
  border: 1px solid ${theme.borderLight};
  @media (max-width: 700px) {
    width: 100%;
    height: 300px;
  }
`;
const Copy = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const Tag = styled.div`
  font-family: ${theme.fontMono};
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${theme.accent};
`;
const Title = styled.div`
  font-family: ${theme.fontDisplay};
  font-size: 26px;
  text-transform: uppercase;
`;
const Desc = styled.div`
  font-size: 14.5px;
  line-height: 1.6;
  color: ${theme.textMuted};
  max-width: 420px;
`;
const Note = styled.div`
  font-family: ${theme.fontMono};
  font-size: 12px;
  color: ${theme.textDim};
`;
const TechRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
`;
const TechTag = styled.div`
  font-family: ${theme.fontMono};
  font-size: 11px;
  padding: 5px 11px;
  background: ${theme.bg};
  border: 1px solid ${theme.borderLight};
  color: ${theme.textMuted};
`;

export default function ThreeDWork() {
  return (
    <Section id="ThreeDWork">
      <Label>3D Modeling</Label>
      <Statement>I also model in 3D, mostly in Fusion 360 these days &mdash; a few pieces I've built, rendered real-time in the browser.</Statement>
      <Grid>
        <Reveal>
          <Card>
            <Viewer><UsnViewer /></Viewer>
            <Copy>
              <Tag>Product Visualization</Tag>
              <Title>USN Hyperbolic Mass</Title>
              <Desc>A modeled and textured 3D product render built for a USN supplement campaign during my time at Hyperboliq.</Desc>
              <TechRow>
                <TechTag>Blender</TechTag>
                <TechTag>Three.js</TechTag>
                <TechTag>React Three Fiber</TechTag>
              </TechRow>
              <Note>Drag to orbit.</Note>
            </Copy>
          </Card>
        </Reveal>
      </Grid>
    </Section>
  );
}
